import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "../Components/Menu/Navbar";
import Home from "../Components/Pages/Home/Home";
import About from "../Components/Pages/About/About";
import ContactUs from "../Components/Pages/Contact/ContactUs";
import Products from "../Components/Pages/Products/Products";
import TermsAndConditions from "../Components/Pages/Terms&Conditions/Terms&Conditions";
import PrivacyPolicy from "../Components/Pages/Privacy&Policy/Privacy&Policy";
import FAQs from "../Components/Pages/FAQS/Faqs";
import Careers from "../Components/Pages/Careers/Careers";

const ConditionalNavbar = () => {
  const location = useLocation();
  const [showNavbar, setShowNavbar] = useState(true);

  useEffect(() => {
    const isHome = location.pathname === "/";
    if (isHome) {
      const showMainContent = localStorage.getItem("showMainContent");
      setShowNavbar(showMainContent === "true");
    } else {
      setShowNavbar(true);
    }
  }, [location]);

  return showNavbar ? <Navbar /> : null;
};

const AppRoutes = () => {
  return (
    <Router>
      <ConditionalNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/products" element={<Products />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/careers" element={<Careers/>} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
